// @flow
import { MessageInputBox, toastError } from 'bench-internal-theme';
import { Mutation } from '@apollo/client/react/components';
import React from 'react';

import { EDIT_LEDGER_ACCOUNT } from './queries';

const handleSaveError = error =>
  toastError(
    'Ledger Details Not Saved',
    `Your changes to the ledger details were not saved. The error was: ${error.message}`,
  );

type EditLedgerDetailsProps = {
  details: string,
  ledgerAccountId: string,
};

const EditLedgerDetailsContainer = ({ details, ledgerAccountId }: EditLedgerDetailsProps) => (
  <Mutation mutation={EDIT_LEDGER_ACCOUNT} onError={handleSaveError}>
    {editLedgerAccount => (
      <MessageInputBox
        allowEmpty
        defaultValue={details}
        onPost={newDetails =>
          editLedgerAccount({
            variables: {
              ledgerAccountId,
              ledgerAccountInput: {
                details: newDetails,
              },
            },
          })
        }
        placeholder="Describe the details of this ledger here"
        postButtonHeapId="ledger-sidebar-details-save-button"
      />
    )}
  </Mutation>
);

export default EditLedgerDetailsContainer;
